'use client';
import { createGesture } from '@s7/gesture';
import { safeWindow } from '../SwipeableDrawer.contract.js';

const VELOCITY_THRESHOLD = 0.15;
const DRAG_THRESHOLD = 200;
const axisCeil = safeWindow.innerHeight;
let cursorOffset = 0;
const reduceAnimationState = (detail)=>{
    const velocity = (detail.velocityX + detail.velocityY) / 2;
    const offset = detail.startY - (detail.currentY + cursorOffset);
    if (velocity >= VELOCITY_THRESHOLD || -offset >= DRAG_THRESHOLD) {
        return 'close';
    }
    return 'open';
};
const getElementOffset = (element)=>element.getBoundingClientRect().top;
const createDrawerSwipeGesture = ({ element, onMove, onChange, onStart })=>{
    cursorOffset = 0;
    return createGesture({
        element,
        gestureName: 'drawer-swipe',
        direction: 'y',
        threshold: 10,
        onEnd: (detail)=>{
            const offset = detail.deltaY - cursorOffset;
            const state = reduceAnimationState(detail);
            onChange(state, offset);
            cursorOffset = detail.startY - getElementOffset(element);
        },
        onMove: (detail)=>{
            const offset = Math.max(0, detail.startY + detail.deltaY - cursorOffset);
            const delta = getElementOffset(element) / axisCeil;
            onMove(offset, delta);
        },
        onStart: (detail)=>{
            cursorOffset = detail.startY - getElementOffset(element);
            onStart == null ? void 0 : onStart(detail);
        }
    });
};

export { createDrawerSwipeGesture };
//# sourceMappingURL=drawerSwipeGesture.js.map
